define 'controller/FilterController', ['jquery', 'custom/media-query', 'lib/kryptonite', 'lib/nouislider','lib/swiper-bundle.min'], ($, mq, krypo, noUiSlider) ->

  class FilterController
    constructor: (@$el) ->
      @selectedActiveClass = @$el.data('selected-active-class')
      @$activeFilterSwiperContainer = @$el.find('[data-controller-element=filter-swiper-container]')
      @$activeFiltersSwiper = @$el.find('[data-controller-element=filter-swiper]')
      @$activeFilterTemplate = @$el.find('#activeFilterTemplate').html()
      @$activeFiltersWrapper = @$el.find('[data-controller-element=active-filters]')
      @$activeFiltersWrapperHiddenClass = @$activeFiltersWrapper.data('hidden-class')

      @$seeMoreButton = @$el.find("[data-controller-element=see-more]")
      @$seeMoreButton.on "click" , @_seeMoreFilter

      @$seeLessButton = @$el.find("[data-controller-element=see-less]")
      @$seeLessButton.on "click" , @_seeLessFilter

      @_resetEvents()
      @_initRangeSliders()
      @_initFilterOpener()
      @_filterEvents()
      @_initFilterSlider()
      @_initFilterCheckBox()

    _initFilterCheckBox: ->
      self = @
      @$el.find("[data-controller-element=filter-list-item] input[type=checkbox]").on 'change', (e) ->
        $el = $(e.currentTarget)
        if $el.hasClass("filter__input--color")
          $colorTileElement = $el.closest('.color-tile')
          if $colorTileElement.length > 0
            $colorTileElement.toggleClass('selected')

        self._handleCountOnLabel($el)
        self._refreshHitCountPreview()
        self._handleSelectedFilterList($el)

    _initFilterSlider: ->
      @swiper = new Swiper @$activeFilterSwiperContainer[0],
        slidesPerView: 'auto',
        spaceBetween: 8,
        grabCursor: true,
        observeParents: true,
        observer: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true
        },
        navigation: {
          nextEl: '.filter-slider__button-next',
          prevEl: '.filter-slider__button-prev'
        },
        a11y: {
          nextSlideMessage: 'Filtres suivants',
          prevSlideMessage: 'Filtres précédents',
          firstSlideMessage: 'Ce sont les premiers filtres',
          lastSlideMessage: 'Ce sont les derniers filtres',
          slideLabelMessage: null,
          slideRole: null
        }

    _setCountLabel: ($filterTypeEl, count) ->
      $filterCountEl = $filterTypeEl.find('.js-accordion-label-info')

      if $filterTypeEl.data('filtertype') == 'min_price'
        $rangeInputs = $filterTypeEl.find('.js-filter-range-input')
        minInput = $rangeInputs[0]
        maxInput = $rangeInputs[1]

        if !(minInput.value == minInput.min && maxInput.value == maxInput.max)
          count += 1

      if count > 0
        $filterCountEl.text("(#{count})")
      else
        $filterCountEl.text("")

    _handleCountOnLabel: ($filterValueEl) ->
      $filterTypeEl = $filterValueEl.closest('[data-controller-element=filter-list-item]')
      selectedFilterSize = $filterTypeEl.find('input[type=checkbox]:checked').length

      @_setCountLabel($filterTypeEl, selectedFilterSize)

    _handleCountOnLabelPrice: ->
      $rangeFilter = @$el.find("[data-filtertype=min_price]")
      selectedFilterSize = $rangeFilter.find('input[type=checkbox]:checked').length

      @_setCountLabel($rangeFilter, selectedFilterSize)

    _handleSelectedFilterList: ($selectedFilterValueEl) ->

      $template = $(@$activeFilterTemplate)
      isReducedFilter = $selectedFilterValueEl.attr('name') == "reduced"
      filterName = $selectedFilterValueEl.closest('[data-controller-element=filter-list-item]').data('filtertype')
      filterValue = $selectedFilterValueEl.data('filter-value')
      filterValueLabel = $selectedFilterValueEl.data('filter-value-label')

      if isReducedFilter
        filterName = 'reduced'
        filterValue = 'T'

      if $selectedFilterValueEl.prop('checked')
        $template.find('[data-controller-element=selected-filter]').attr({
          'data-active-filtertype' : "#{filterName}",
          'data-active-filter-value' : "#{filterValue}"
        })
        $template.find('[data-controller-element=selected-filter-name]').text(filterValueLabel)

        if !@$el.hasClass(@selectedActiveClass)
          @_showSelectedFiltersArea()

        @$activeFiltersSwiper.append($template)
        @swiper.update()

      else
        $filteType = @$activeFiltersSwiper.find("[data-active-filtertype=#{filterName}]")

        if isReducedFilter
          $filteType.closest('[data-controller-element=selected-filter-wrap]').remove()

        $filteType.filter ->
          if $(@).data('active-filter-value') == filterValue
            $(@).closest('[data-controller-element=selected-filter-wrap]').remove()
            return

        @swiper.update()

        if @$el.find('[data-controller-element=selected-filter-wrap]').length < 1
          @_handleSelectedFiltersArea()

    _handleSelectedRangeFilterInList: (minVal, maxVal, defaultMin, defaultMax) ->
      filterName ='min_price'
      $selectedPriceFilter = @$activeFiltersSwiper.find("[data-active-filtertype=#{filterName}]")
      filterValueLabel = "Prix : #{minVal}€ - #{maxVal}€"

      if minVal == defaultMin && maxVal == defaultMax
        $selectedPriceFilter.closest('[data-controller-element=selected-filter-wrap]').remove()
        if @$el.find('[data-controller-element=selected-filter-wrap]').length < 1
          @_handleSelectedFiltersArea()
      else
        if $selectedPriceFilter.length > 0
          $selectedPriceFilter.find('[data-controller-element=selected-filter-name]').text(filterValueLabel)
        else
          $template = $(@$activeFilterTemplate)
          $template.find('[data-controller-element=selected-filter]').attr('data-active-filtertype', filterName)
          $template.find('[data-controller-element=selected-filter-name]').text(filterValueLabel)

          if !@$el.hasClass(@selectedActiveClass)
            @_showSelectedFiltersArea()

          @$activeFiltersSwiper.append($template)

      @swiper.update()


    _seeMoreFilter: (e) ->
      $el = $(e.currentTarget)
      $activeFilter = $el.closest("[data-controller-element=filter-container]")
      $activeFilter.find("[data-controller-element=filter-item]").slice(5).removeClass("hidden")
      $activeFilter.find("[data-controller-element=see-less]").addClass("active")
      $el.removeClass("active")

    _seeLessFilter: (e) ->
      $el = $(e.currentTarget)
      $activeFilter = $el.closest("[data-controller-element=filter-container]")
      $activeFilter.find("[data-controller-element=filter-item]").slice(5).addClass("hidden")
      $activeFilter.find("[data-controller-element=see-more]").addClass("active")
      $el.removeClass("active")

    _initFilterOpener: ->
      @$openFilterButton = @$el.find('[data-controller-element=filter-open-button]')

      @$openFilterButton.on 'click', =>
        @_openFilter()

    _initRangeSliders: ->
      self = this
      @$el.find('.js-filter-range-slider').each () -> self._initRangeSlider(this)

    _initRangeSlider: (slider) ->
      self = this
      $filter = this._getFilter($(slider))
      $rangeFilterInputs = $filter.find('.filter__range-value')
      inputMin = $rangeFilterInputs[0]
      inputMax = $rangeFilterInputs[1]

      noUiSlider.create(slider, {
        start: [Number(inputMin.value), Number(inputMax.value)],
        connect: true,
        range: {
          'min': Number(inputMin.min),
          'max': Number(inputMax.max),
        },
        handleAttributes: [
          { 'aria-label': 'Prix minimum en Euro' },
          { 'aria-label': 'Prix maximum en Euro' },
        ],
      })

      inputMin.addEventListener('keydown', @_acceptOnlyNumbers, false)
      inputMax.addEventListener('keydown', @_acceptOnlyNumbers, false)

      inputMin.addEventListener 'focus', () ->
        inputMin.value = ''
      inputMax.addEventListener 'focus', () ->
        inputMax.value = ''

      inputMin.addEventListener 'blur', () ->
        if not inputMin.value
          inputMin.value = Number(slider.noUiSlider.get()[0])
      inputMax.addEventListener 'blur', () ->
        if not inputMax.value
          inputMax.value = Number(slider.noUiSlider.get()[1])

      inputMin.addEventListener 'change', () ->
        currentValue = this.value

        if not currentValue
          currentValue = inputMin.min

        clampedValue = currentValue

        if Number(currentValue) > Number(inputMax.value)
          inputMin.value = inputMax.value
          clampedValue = inputMax.value

        slider.noUiSlider.set([clampedValue, null])
        self._refreshHitCountPreview()
        self._handleCountOnLabelPrice()
        self._handleSelectedRangeFilterInList(inputMin.value, inputMax.value, inputMin.min, inputMin.max)

      inputMax.addEventListener 'change', () ->
        currentValue = this.value

        if not currentValue
          currentValue = inputMax.max

        clampedValue = currentValue

        if Number(currentValue) < Number(inputMin.value)
          inputMax.value = inputMin.value
          clampedValue = inputMin.value

        slider.noUiSlider.set([null, clampedValue])
        self._refreshHitCountPreview()
        self._handleCountOnLabelPrice()
        self._handleSelectedRangeFilterInList(inputMin.value, inputMax.value, inputMin.min, inputMin.max)

      inputMin.addEventListener 'blur', () ->
      inputMax.addEventListener 'blur', () ->
        if Number(inputMax.value) < Number(inputMin.value)
          inputMax.value = inputMin.value

      slider.noUiSlider.on('update', (values, handle) ->
        value = values[handle];

        if handle
          inputMax.value = Math.round(value)
        else
          inputMin.value = Math.round(value)
      )
      slider.noUiSlider.on('end', ()->
        self._refreshHitCountPreview()
        self._handleCountOnLabelPrice()
        self._handleSelectedRangeFilterInList(inputMin.value, inputMax.value, inputMin.min, inputMin.max)
      )

    _acceptOnlyNumbers: (e) ->
      ###
       * Line A: Don't do anything if the Control or Alt keys are pressed down,
       * as we don't want to prevent the user from using keyboard shortcuts.
       *
       * Line B: Make sure we're only handling strings, as those are the only
       * type of value that we are expecting.
       *
       * Line C: We only need to filter out single characters. This is important
       * because it allows us to continue using keys such as Home, End, and
       * Enter, all of which are useful for maneuvering the form, and all of which
       * are longer than 1 character.
      ###

      if event.ctrlKey or event.altKey or # (A)
         typeof event.key != 'string' or # (B)
         event.key.length != 1 # (C)
        return

      if !new RegExp('[0-9]').test(event.key)
        event.preventDefault()
        return

    _filterEvents: ->
      self = @
      $('[data-controller-element=button-submit-filter]').on 'click', (e) ->
        $this = $(this)
        e.preventDefault()
        $activeFilter = self._getFilter($this)
        self._updateLocalStorage($activeFilter)

        url = self._buildFilterUrl()
        self._applyFilter(url.href, true, true)

    _buildFilterUrl: ->
      self = @
      url = new URL(window.location)
      $('[data-filtertype]').each () ->
        self._addFilterToUrl(url, $(this))
      self._handleReducedFilter(url)
      self._handleSorting(url)
      return url

    _handleReducedFilter: (url) ->
      # Special case: the checkbox for the discounted products in the price filter
      reducedFilterName = 'reduced'

      if $('input[name=\''+ reducedFilterName + '\']').prop('checked')
        url.searchParams.set(reducedFilterName, 'T')
      else
        url.searchParams.delete(reducedFilterName)

    _handleSorting: (url) ->
      checked = @$el.find('[name="categorySorting"]:checked')
      sortingVal = checked.val()
      label = $("label[for='"+checked.attr("id")+"']").text()
      if(dataLayer)
        dataLayer.push({
          "event": 'clics_trier',
          "element": label
        });
      url.searchParams.set('sort', sortingVal)

    _addFilterToUrl: (url, $filter) ->
      filterName = this._getFilterName($filter)
      filterValues = this._getActiveFilterValues($filter)
      if (filterValues.length == 0)
        url.searchParams.delete(filterName)
      else
        url.searchParams.set(filterName, filterValues.join('|'))

      url.searchParams.delete('page')

    _showSelectedFiltersArea: ->
      @$activeFiltersWrapper.attr('aria-hidden', 'false')
      @$activeFiltersWrapper.removeClass(@$activeFiltersWrapperHiddenClass)
      @$el.addClass(@selectedActiveClass)

    _handleSelectedFiltersArea: (resetAllFilters) ->
      @$activeFiltersWrapper.addClass(@$activeFiltersWrapperHiddenClass)
      @$activeFiltersWrapper.attr('aria-hidden', 'true')
      @$el.removeClass(@selectedActiveClass)

      if resetAllFilters
        @$activeFiltersSwiper.empty()

    _resetRangeFilter: (filterName, refreshHit) ->
      $rangeFilter = @$el.find("[data-filtertype=#{filterName}]")
      $rangeSlider = $rangeFilter.find('.js-filter-range-slider')
      $rangeInputs = $rangeFilter.find('.js-filter-range-input')

      minInput = $rangeInputs[0]
      maxInput = $rangeInputs[1]

      minInput.value = minInput.min
      maxInput.value = maxInput.max
      $rangeSlider[0].noUiSlider.set([minInput.min, maxInput.max])

      if refreshHit
        @_refreshHitCountPreview()

    _resetEvents: ->
      self = @
      @$el.on 'click', '[data-controller-element=selected-filter]', (e) ->
        e.preventDefault()
        $el = $(e.currentTarget)
        $elWrap = $el.closest('[data-controller-element=selected-filter-wrap]')
        activeFilterName = $el.data('active-filtertype')
        activeFilterValue = $el.data('active-filter-value')

        if activeFilterName == 'reduced'
          self.$el.find("#filterReducedOnly").click()
          $elWrap.remove()
        else if activeFilterName == 'min_price'
          self._resetRangeFilter('min_price', true)
          self._handleCountOnLabelPrice()
          $elWrap.remove()
        else
          self.$el.find("[data-filtertype=#{activeFilterName}] [data-filter-value]:checked").filter ->
            if $(@).data('filter-value') == activeFilterValue
              $(@).click()
              $elWrap.remove()

        self.swiper.update()

        if self.$el.find('[data-controller-element=selected-filter-wrap]').length < 1
          self._handleSelectedFiltersArea()

      $('[data-controller-element=delete-all-selected-filters]').on 'click', (e) ->
        # reset all checked checkboxes
        self.$el.find('[data-filter-value]:checked, #filterReducedOnly:checked').prop('checked', false)
        self.$el.find('.color-tile').removeClass('selected')

        # reset range filter
        self._resetRangeFilter('min_price')

        # reset all count value on label
        self.$el.find('.js-accordion-label-info').text("")

        url = new URL(window.location)
        self._refreshHitCountPreview(url)

        self._handleSelectedFiltersArea(true)

      $('.filter-list').on 'click', '[data-controller-element=button-submit-with-url][data-url]', (e) ->
        e.preventDefault()
        $('html, body').css
            overflow: 'initial'
            height: 'auto'
        self._applyFilter($(@).data('url'), true, true)

    _applyFilter: (url, isInModalOverlay, closeModalOverlay) ->
      self = @
      $openFilters = $('#modalOverlayRight').find('.dropdown--opened').closest('[data-filtertype]')

      # reload for older browsers
      unless history.pushState?
          window.location = url
          return

      history.pushState(null, null, url)

      $('body').addClass('loading')

      if closeModalOverlay
        $('#modalOverlayRight').modal('hide')

      $.kryptonite
        data:
          mobileFilter: mq.up_to_M && isInModalOverlay
        url: url
        type: 'POST' # NOTE: see CategoryController
        complete: (response) ->
          if !closeModalOverlay
            # empty the filter list since it's already displayed in the modal (still open)
            $('#filterListModalContent').html("")

            # reopen filters that where opened before filtering (in case the modal stays open)
            $openFilters.each () ->
              filtertype = $(this).data('filtertype')
              self._setOpenFilterClasses($('#modalOverlayRight').find("[data-filtertype=#{filtertype}]"))

          $('body').removeClass('loading')
          $('body, html').animate({scrollTop: 0}, 500)

          if dataLayer? && (!mq.up_to_M || !isInModalOverlay)
            updatedDataLayer = $(response.responseText).filter('#dataLayer').data('eval')
            if updatedDataLayer
              dataLayer.push({
                event: 'viewList',
                'first_item': updatedDataLayer.first_item,
                'second_item': updatedDataLayer.second_item,
                'third_item': updatedDataLayer.third_item
              })

    _updateLocalStorage: ($activeFilter) ->
      activeFilterName = this._getFilterName($activeFilter)
      localStorage.removeItem('opened-filter')
      window.localStorage.setItem('opened-filter', activeFilterName);

    _getFilter: ($element) ->
      return $element.closest('.filter-list__item')

    _getFilterName: ($filter) ->
      return $filter.attr('data-filtertype')

    _getActiveFilterValues: ($filter) ->
      $rangeFilterInputs = $filter.find('.filter__range-value')
      filterValuesInSum

      if $rangeFilterInputs.length  #range filter
        filterValuesInSum = this._getRangeFilterValue($rangeFilterInputs)
        return filterValuesInSum
      else #checkbox filter
        $activeFilterValues = $filter.find('input[type=checkbox]:checked')
        return $activeFilterValues.map(() -> $(this).attr('data-filter-value')).get()

    _getRangeFilterValue: ($rangeFilterInputs) ->
      valueMin = $rangeFilterInputs[0].value
      valueMax = $rangeFilterInputs[1].value

      limitMin = $rangeFilterInputs[0].min
      limitMax = $rangeFilterInputs[1].max

      if limitMin == valueMin && limitMax == valueMax
        return []

      rangeValue = valueMin + '<>' + valueMax;
      return [rangeValue]

    _refreshHitCountPreview: (filterUrl) ->
      self = this
      $submitButton = @$el.find("[data-controller-element=button-submit-filter]")
      $submitButtonText = $submitButton.find('[data-controller-element=button-submit-text]')
      if filterUrl
        target = "/hits?externalKey=" + filterUrl.pathname
      else
        url = self._buildFilterUrl()
        target = "/hits?externalKey=" + url.pathname + url.search.replace("?", "&")

      $.ajax
        url: target
        xhrFields:
          showLoadingIndicator: false
        complete: (data) ->
          json = $.parseJSON(data.responseText);
          $submitButtonText.text(json.message)
          if json.status == "ko"
            $submitButton.addClass("disabled")
            $submitButton.attr("disabled", true)
          else
            $submitButton.removeClass("disabled")
            $submitButton.removeAttr("disabled")

    _setOpenFilterClasses: ($openFilter) ->
      $openFilter.find('.dropdown').addClass('dropdown--opened')
      $openFilter.find('.dropdown__content').addClass('dropdown__content--visible')
      $openFilter.find('.dropdown__icon').addClass('dropdown__icon--opened')
      $openFilter.find('.dropdown__title').addClass('dropdown__title--invisible')
      $openFilter.find('.dropdown__title-opened').addClass('dropdown__title-opened--visible')

    _openFilter: ->
      filtertype = window.localStorage.getItem('opened-filter')
      $openFilter = $('.filter-list__item[data-filtertype="'+filtertype+'"]')

      @_setOpenFilterClasses($openFilter)
      @_closeSubFilter()

    _closeSubFilter: ->
      $('#filterList').find('.dropdown--opened').removeClass('dropdown--opened')
      $('#filterList').find('.dropdown__content').removeClass('dropdown__content--visible')
      $('#filterList').find('.dropdown__icon').removeClass('dropdown__icon--opened')
      $('#filterList').find('.dropdown__title').removeClass('dropdown__title--invisible')
      $('#filterList').find('.dropdown__title-opened').removeClass('dropdown__title-opened--visible')
      $('#filterList').find('.dropdown__icon').removeClass('dropdown__icon--mobile-opened')
      $('#filterList').find('.dropdown__content').removeClass('dropdown__content--mobile-visible')

    destroy: ->
      @$el.off()